/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theeventyourelookingfordoesntexist6Inputs */

const en_theeventyourelookingfordoesntexist6 = /** @type {(inputs: Theeventyourelookingfordoesntexist6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The event you're looking for doesn't exist`)
};

const de_theeventyourelookingfordoesntexist6 = /** @type {(inputs: Theeventyourelookingfordoesntexist6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Event gibt es nicht.`)
};

/**
* | output |
* | --- |
* | "The event you're looking for doesn't exist" |
*
* @param {Theeventyourelookingfordoesntexist6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const theeventyourelookingfordoesntexist6 = /** @type {((inputs?: Theeventyourelookingfordoesntexist6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theeventyourelookingfordoesntexist6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_theeventyourelookingfordoesntexist6(inputs)
	return de_theeventyourelookingfordoesntexist6(inputs)
});
export { theeventyourelookingfordoesntexist6 as "theEventYoureLookingForDoesntExist" }